import { api } from "./client";

export interface AuditLogItem {
  id: string;
  user_id: string;
  action: string;
  target_model: string;
  target_id: string | null;
  before_state: Record<string, unknown> | null;
  after_state: Record<string, unknown> | null;
  ip_address: string | null;
  created_at: string;
}

export interface DailyCost {
  date: string;
  cost_usd: number;
  runs: number;
  tokens_in: number;
  tokens_out: number;
}

export interface CostStats {
  total_usd: number;
  by_day: DailyCost[];
  top_users: Array<Record<string, unknown>>;
}

export interface ToolUsage {
  tool_name: string;
  total_calls: number;
  success_count: number;
  avg_latency_ms: number;
}

// Doc 47: UserBrief + adminApi.users moved to api/users.ts với schema mới
// (nullable Odoo identity + roles + has_password).

export const adminApi = {
  auditLogs: (params: {
    days_back?: number;
    user_id?: string;
    target_model?: string;
    action?: string;
    limit?: number;
  } = {}) =>
    api.get<{ items: AuditLogItem[]; has_more: boolean }>(
      "/api/v1/admin/audit-logs",
      { query: params },
    ),
  costStats: (days_back = 7) =>
    api.get<CostStats>("/api/v1/admin/stats/cost", { query: { days_back } }),
  toolStats: (days_back = 7) =>
    api.get<ToolUsage[]>("/api/v1/admin/stats/tools", { query: { days_back } }),
};
